// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStorePlugin = (client) => ({
    /**
     * `GET /store/plugin`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePluginList
     * @source packages/medusa-plugin-searates-v2/src/api/store/plugin/route.ts
     */
    list: (query, headers) => client.fetch("/store/plugin", { method: "GET", query, headers }),
});
//# sourceMappingURL=plugin.js.map